var HistoryCarrousel = {
	init:function(){
	
		var brief_history_carousel = $('.history .history-carousel').slick({
			centerPadding: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:true,
			arrows:true,
			dots:false,	
			appendArrows:$('.history .history-carousel-wrapper .controls'),
			asNavFor: '.history-carousel-year-details',
			prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 8" style="enable-background:new 0 0 21 8;" xml:space="preserve"><path srtyle="fill-rule:evenodd;clip-rule:evenodd;enable-background:new" d="M21,3v2H4v3L0,4l4-4v3H21z"/></svg></button>',
			nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 8" style="enable-background:new 0 0 21 8;" xml:space="preserve"><path style="fill-rule:evenodd;clip-rule:evenodd;" d="M0,3v2h17v3l4-4l-4-4v3H0z"/></svg></button>'
		}); 

		var brief_history_content =  $('.history .history-carousel-year-details').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false, 
			fade: true,
			arrows:false,
			dots:false,	
			swipe:false,
			draggable:false,
			touchMove:false
		});	
	}
};


